import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './components/login/login.component';
import { AuthRoutingModule } from './auth-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from './services/auth.service';
import { AuthGuard } from './services/auth-guard.service';
import { ProfileComponent } from './components/profile/profile.component';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AuthRoutingModule,
    ReactiveFormsModule,
    FormlyModule,
    FormlyBootstrapModule
  ],
  exports: [
    LoginComponent,
    ProfileComponent
  ],
  providers: [AuthService, AuthGuard],
  entryComponents: [ProfileComponent],
  declarations: [LoginComponent, ProfileComponent]
})
export class AuthModule {
}
